const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function initHeaderScroll() {
  const header = document.querySelector(".header");
  if (!header) return;
  const sync = () => header.classList.toggle("scrolled", window.scrollY > 24);
  sync();
  window.addEventListener("scroll", sync, { passive: true });
}

function initMobileNav() {
  const toggle = document.getElementById("nav-toggle");
  const links = document.querySelector(".nav-links");
  if (!toggle || !links) return;
  const close = () => {
    links.classList.remove("open");
    toggle.setAttribute("aria-expanded", "false");
  };
  toggle.addEventListener("click", () => {
    const open = links.classList.toggle("open");
    toggle.setAttribute("aria-expanded", String(open));
  });
  links.querySelectorAll("a").forEach((a) => a.addEventListener("click", close));
}

function initSpotlight() {
  const spotlight = document.querySelector(".spotlight");
  const hero = document.querySelector(".hero");
  if (!spotlight || !hero || reducedMotion) return;
  hero.addEventListener(
    "pointermove",
    (e) => {
      spotlight.style.setProperty("--mx", `${e.clientX}px`);
      spotlight.style.setProperty("--my", `${e.clientY}px`);
      spotlight.style.opacity = "1";
    },
    { passive: true },
  );
  hero.addEventListener("pointerleave", () => {
    spotlight.style.opacity = "0";
  });
}

function initMarquee() {
  const track = document.getElementById("marquee-track");
  if (track) track.innerHTML += track.innerHTML;
}

function initYear() {
  const year = document.getElementById("year");
  if (year) year.textContent = String(new Date().getFullYear());
}

function fillCountsImmediately() {
  document.querySelectorAll("[data-count]").forEach((el) => {
    const target = Number(el.dataset.count || "0");
    const decimals = Number(el.dataset.decimals || "0");
    el.textContent = target.toFixed(decimals) + (el.dataset.suffix || "");
  });
  document.querySelectorAll("[data-bar]").forEach((el) => {
    el.style.width = `${el.dataset.bar}%`;
  });
  document.querySelectorAll(".metric").forEach((el) => el.classList.add("in"));
}

function animateCount(root) {
  const nodes = root.matches("[data-count]")
    ? [root]
    : Array.from(root.querySelectorAll("[data-count]"));
  for (const el of nodes) {
    if (el.dataset.done) continue;
    el.dataset.done = "1";
    const target = Number(el.dataset.count || "0");
    const decimals = Number(el.dataset.decimals || "0");
    const suffix = el.dataset.suffix || "";
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / 1400);
      const eased = 1 - (1 - t) ** 3;
      el.textContent = (target * eased).toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals) + suffix;
    };
    requestAnimationFrame(step);
  }
}

function initReveals() {
  const nodes = document.querySelectorAll(".reveal, [data-reveal-stagger]");
  if (reducedMotion || !("IntersectionObserver" in window)) {
    nodes.forEach((el) => el.classList.add("in"));
    fillCountsImmediately();
    return;
  }

  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        el.classList.add("in");
        if (el.hasAttribute("data-reveal-stagger")) {
          Array.from(el.children).forEach((child, i) => {
            child.style.transitionDelay = `${i * 90}ms`;
          });
        }
        if (el.querySelector("[data-count]") || el.hasAttribute("data-count")) {
          animateCount(el);
        }
        el.querySelectorAll("[data-bar]").forEach((bar, i) => {
          setTimeout(() => {
            bar.style.width = `${bar.dataset.bar}%`;
          }, 200 + i * 120);
        });
        if (el.classList.contains("metric")) el.classList.add("in");
        observer.unobserve(el);
      }
    },
    { threshold: 0.2, rootMargin: "0px 0px -8% 0px" },
  );

  nodes.forEach((el) => io.observe(el));
  document.querySelectorAll(".metric").forEach((el) => io.observe(el));
}

export function initUi() {
  initHeaderScroll();
  initMobileNav();
  initSpotlight();
  initMarquee();
  initYear();
  initReveals();
}
